(() => {
  // app/scripts/header.js
  var CustomHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.elms = {
        desktopMenu: this.querySelector(".js-header-menu"),
        desktopMenuOrigin: this.querySelector(".js-header-menu")?.cloneNode(true),
        drawerElms: {
          mobileDrawerTemplate: this.querySelector("#header-mobile-drawer-wrapper"),
          mobileDrawerHamburger: this.querySelector(".js-header-drawer-hamburger"),
          mobileDrawerMenu: null,
          mobileDrawerMenuOrigin: null,
          mobileDrawerCloseButton: this.querySelector(".js-header-drawer-close-btn")
        },
        searchElms: {
          searchTriggerIcon: this.querySelectorAll(".js-search-toggle-icon")
        },
        desktopHamburger: this.querySelector(".js-header-sticky-hamburger")
      };
      this.mediaQuery = window.matchMedia("(min-width: 992px)");
      this.header = document.querySelector(".section-header-wrapper");
      this.stickyType = this.getAttribute("data-sticky-type");
      this.initSticky();
      this.initDesktopNavigation();
      this.initDesktopHamburgerButton();
      this.initMobileDrawer();
      this.initSearchEvents();
      this.initEditorEvents();
      this.setHeaderRect();
      this.mediaQuery.addEventListener("change", this.setHeaderRect.bind(this));
    }
    disconnectedCallback() {
      if (this.stickyType !== "none") {
        this.mediaQuery.removeEventListener("change", this.setHeaderHeight.bind(this));
        window.removeEventListener("scroll", this.onScroll.bind(this));
      }
      if (this.calculateDropdownPositionHandler) {
        this.mediaQuery.removeEventListener("change", this.calculateDropdownPositionHandler);
      }
      if (Shopify.designMode) {
        document.removeEventListener("shopify:section:load", this.onSectionChange);
        document.removeEventListener("shopify:section:unload", this.onSectionChange);
        document.removeEventListener("shopify:section:select", this.editorSelectEventCallback);
      }
      this.mediaQuery.removeEventListener("change", this.setHeaderRect.bind(this));
    }
    setHeaderRect() {
      document.documentElement.style.setProperty("--header-bottom", `${Math.round(this.header.getBoundingClientRect().bottom + window.scrollY)}px`);
    }
    initSticky() {
      if (this.stickyType === "none")
        return;
      this.headerIsAlwaysSticky = this.stickyType === "always" || this.stickyType === "reduce-logo-size";
      this.stickyElement = this.querySelector(".js-header-sticky-element") || this.header;
      this.stickyElementBoundTop = this.stickyElement.getBoundingClientRect().top + window.scrollY;
      this.stickyElementBoundBottom = this.stickyElement.getBoundingClientRect().bottom + window.scrollY;
      this.setHeaderHeight();
      this.mediaQuery.addEventListener("change", this.setHeaderHeight.bind(this));
      const stickyTypeClass = `sticky-type-${this.stickyType}`;
      this.header.classList.add(stickyTypeClass);
      this.lastScroll = 0;
      window.addEventListener("scroll", this.onScroll.bind(this));
      this.preventHide = false;
      this.showHeaderOnScrollDown = () => this.preventHide = true;
      this.addEventListener("preventHeaderHide", this.showHeaderOnScrollDown);
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
      this.header.style.setProperty("--header-top-height", `${this.header.offsetHeight - this.stickyElement.offsetHeight}px`);
    }
    onScroll() {
      const currentScroll = window.scrollY;
      if (currentScroll > this.lastScroll && currentScroll > this.stickyElementBoundBottom) {
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.add("scrolled-past-header");
          if (!this.preventHide) {
            this.header.classList.add("header-hide-on-scroll-down");
          } else {
            this.preventHide = false;
          }
        } else {
          this.header.classList.add("scrolled-past-header-top");
        }
      } else if (currentScroll < this.lastScroll && currentScroll > this.stickyElementBoundBottom) {
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.add("scrolled-past-header");
          this.header.classList.remove("header-hide-on-scroll-down");
        } else {
          this.header.classList.add("scrolled-past-header-top");
        }
      } else {
        if (currentScroll <= this.stickyElementBoundTop) {
          this.header.classList.remove("scrolled-past-header", "scrolled-past-header-top", "header-hide-on-scroll-down");
        }
      }
      this.lastScroll = currentScroll;
    }
    initDesktopNavigation() {
      let firstLevelMenuItems = this.querySelectorAll(".js-menu-item");
      firstLevelMenuItems.forEach((item) => {
        if (Shopify.designMode) {
          const tempElement = item.querySelector(":scope > div:last-child");
          if (!!tempElement) {
            const md5Code = tempElement.classList[0];
            const megaMenuSection = document.querySelector(`.mega-menu-editor[data-code="${md5Code}"]`);
            if (!!megaMenuSection) {
              const megaMenuSectionClone = megaMenuSection.cloneNode(true);
              megaMenuSectionClone.classList.remove("d-none");
              item.appendChild(megaMenuSectionClone);
              tempElement.remove();
            }
          }
        }
        if (item.querySelector("template") || item.querySelector(".mega-menu-editor")) {
          item.classList.add("has-dropdown", "mega-menu-item");
          item.querySelector(":first-child a").setAttribute("aria-expanded", "false");
        }
        ["mouseenter", "focusin"].forEach((event) => {
          item.addEventListener(event, () => {
            const megaMenuTemplate = item.querySelector(".temp-id") || item.querySelector(".mega-menu-editor");
            if (!megaMenuTemplate)
              return;
            item.querySelector(".dropdown-menu--sublinks")?.remove();
            if (item.querySelector(".temp-id")) {
              item.appendChild(megaMenuTemplate.content);
              megaMenuTemplate.remove();
            }
            this.#adjustMegaContentPosition(item);
          }, { once: true });
        });
        item.addEventListener("mouseenter", (e) => {
          this.#openDropdown(item);
        });
        item.addEventListener("mouseleave", (e) => {
          this.#closeDropdown(item);
        });
        item.querySelector(":first-child a").addEventListener("focusout", (e) => {
          if (!e.relatedTarget || !item.contains(e.relatedTarget)) {
            this.#closeDropdown(item);
          }
        });
        item.addEventListener("focusin", (e) => {
          if (e.target.closest(".js-item-link-wrapper")) {
            if (!e.relatedTarget || !item.contains(e.relatedTarget)) {
              this.#openDropdown(item);
            }
          } else {
            const megaContent = item.querySelector("mega-menu, .dropdown-menu--sublinks");
            const elements = this.#getFocusableElements(megaContent);
            const first = elements[0];
            const last = elements[elements.length - 1];
            if (e.target === first || e.target === last) {
              let keydown2 = function(evt) {
                if (evt.code.toUpperCase() !== "TAB")
                  return;
                if (evt.target === first && evt.shiftKey || evt.target === last && !evt.shiftKey) {
                  this.#closeDropdown(item);
                }
              };
              var keydown = keydown2;
              megaContent.addEventListener("keydown", keydown2.bind(this));
              megaContent.addEventListener("focusout", () => {
                megaContent.removeEventListener("keydown", keydown2.bind(this));
              });
            }
          }
        });
        item.addEventListener("keyup", (e) => {
          const ariaExpandedAttr = item.querySelector(":first-child a").getAttribute("aria-expanded");
          switch (e.code.toUpperCase()) {
            case "ESCAPE":
              e.preventDefault();
              if (ariaExpandedAttr == "false" || ariaExpandedAttr == null)
                return;
              e.stopPropagation();
              this.#closeDropdown(item);
              if (e.target.closest("mega-menu") || e.target.closest(".dropdown-menu--sublinks")) {
                item.querySelector(":first-child a").focus();
              }
              break;
            case "SPACE":
              if (!e.target.closest("c-tabs"))
                e.preventDefault();
              if (ariaExpandedAttr == "true" || ariaExpandedAttr == null)
                return;
              this.#openDropdown(item);
              break;
          }
        });
        item.addEventListener("keydown", (e) => {
          if (!e.target.closest(".js-item-link-wrapper"))
            return;
          switch (e.code.toUpperCase()) {
            case "SPACE":
              e.preventDefault();
              break;
          }
        });
        if (item.classList.contains("has-dropdown") && !item.classList.contains("mega-menu-item")) {
          this.#calculateDropdownPosition(item);
          this.calculateDropdownPositionHandler = this.#calculateDropdownPosition.bind(this, item);
          this.mediaQuery.addEventListener("change", this.calculateDropdownPositionHandler);
        }
      });
    }
    #adjustMegaContentPosition(container, megaContentContainer = container) {
      const megaContent = megaContentContainer.querySelector("mega-menu .dropdown-menu--mega");
      if (!megaContent)
        return;
      const clientWidth = document.body.clientWidth;
      const pageWidth = window.theme.settings.pageWidth;
      const containerWidth = clientWidth > pageWidth ? pageWidth - 20 : clientWidth - 20;
      const megaContentWidth = parseInt(getComputedStyle(megaContent).width) * containerWidth / 100;
      const megaContentRectLeft = (clientWidth - containerWidth) / 2;
      const megaContentRectRight = megaContentRectLeft + megaContentWidth;
      const menuItemRect = container.getBoundingClientRect();
      if (megaContentRectRight < menuItemRect.left) {
        megaContent.style.left = menuItemRect.right - megaContentRectRight + "px";
      }
    }
    #calculateDropdownPosition(container) {
      if (!this.mediaQuery.matches || !container) {
        container?.querySelector(":scope > ul")?.classList.remove("align-right");
        return;
      }
      const item_x = container.getBoundingClientRect().left;
      const body_width = document.body.clientWidth;
      const distance = Math.floor(body_width - item_x - 20);
      const dropdown_needs = container.querySelector(".has-sub-dropdown") ? 245 * 2 : 245;
      if (distance < dropdown_needs) {
        container.querySelector(":scope > ul").classList.add("align-right");
      }
    }
    #openDropdown(container) {
      container.addClass("open");
      if (container.classList.contains("has-dropdown")) {
        container.querySelector(":first-child a").setAttribute("aria-expanded", "true");
      }
    }
    #closeDropdown(container) {
      container.removeClass("open");
      if (container.classList.contains("has-dropdown")) {
        container.querySelector(":first-child a").setAttribute("aria-expanded", "false");
      }
    }
    initDesktopHamburgerButton() {
      this.elms.desktopHamburger.addEventListener("click", (e) => {
        this.classList.toggle("show-menu");
        this.dispatchEvent(new CustomEvent("preventHeaderHide"));
      });
    }
    initSearchEvents() {
      const { searchTriggerIcon } = this.elms.searchElms;
      if (searchTriggerIcon.length == 0)
        return;
      this.searchFocusTrap = [];
      this.searchPopups = [];
      searchTriggerIcon.forEach((icon, index) => {
        if (icon.nextElementSibling && icon.nextElementSibling.tagName == "SEARCH-FORM") {
          this.searchPopups.push(icon.nextElementSibling);
        } else {
          if (this.querySelector("search-form")) {
            this.searchPopups.push(this.querySelector("search-form"));
          } else {
            this.searchPopups.push(null);
          }
        }
        if (this.searchPopups.length == 0)
          return;
        this.searchFocusTrap.push(window.focusTrap.createFocusTrap(icon.parentElement, { escapeDeactivates: false, allowOutsideClick: true }));
        icon.addEventListener("click", (e) => {
          const target = e.target;
          target.classList.toggle("active");
          this.toggleSearchPopup(index);
          this.dispatchEvent(new CustomEvent("preventHeaderHide"));
        });
      });
      this.addEventListener("click", function(event) {
        const target = event.target;
        const activeSearchForms = this.querySelectorAll("search-form.active");
        if (target.classList.contains("js-search-toggle-icon") || activeSearchForms.length == 0)
          return;
        activeSearchForms.forEach((form) => {
          if (!form.contains(target) && form.previousElementSibling && form.previousElementSibling.classList.contains("js-search-toggle-icon"))
            form.previousElementSibling.click();
        });
      });
    }
    toggleSearchPopup(index) {
      const popup = this.searchPopups[index];
      const overlay = popup.nextElementSibling;
      if (!popup || !overlay)
        return;
      popup.classList.toggle("active");
      overlay.classList.toggle("active");
      if (popup.classList.contains("active")) {
        popup.querySelector('input[name="q"]').focus();
        this.searchFocusTrap[index].activate();
        AT.disableScroll(false);
      } else {
        this.searchFocusTrap[index].deactivate();
        AT.enableScroll();
      }
    }
    initMobileDrawer() {
      let { mobileDrawerHamburger, mobileDrawerCloseButton } = this.elms.drawerElms;
      this.isDrawerInitialized = false;
      mobileDrawerHamburger.addEventListener("click", function() {
        if (!this.isDrawerInitialized) {
          this.initializeDrawer();
        }
        this.openDrawer();
      }.bind(this));
      mobileDrawerCloseButton.addEventListener("click", this.closeDrawer.bind(this));
    }
    initializeDrawer() {
      let { mobileDrawerTemplate, mobileDrawerMenu } = this.elms.drawerElms;
      if (!mobileDrawerTemplate || this.isDrawerInitialized)
        return;
      let div = document.createElement("div");
      div.innerHTML = mobileDrawerTemplate.innerHTML;
      mobileDrawerTemplate.insertAdjacentElement("beforebegin", div.firstElementChild);
      mobileDrawerTemplate.remove();
      this.elms.drawerElms.mobileDrawerMenu = mobileDrawerMenu = this.querySelector("#header-mobile-drawer");
      this.elms.drawerElms.mobileDrawerMenuOrigin = mobileDrawerMenu?.cloneNode(true);
      if (!mobileDrawerMenu)
        return;
      this.bindDrawerEvents();
      this.isDrawerInitialized = true;
    }
    bindDrawerEvents() {
      const { mobileDrawerMenu, mobileDrawerCloseButton } = this.elms.drawerElms;
      if (!mobileDrawerMenu)
        return;
      if (!this.drawerFocusTrap) {
        const trap = window.focusTrap.createFocusTrap([mobileDrawerCloseButton.parentElement, mobileDrawerMenu], {
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: mobileDrawerMenu
        });
        this.drawerFocusTrap = {
          element: mobileDrawerMenu,
          trap
        };
      }
      mobileDrawerMenu.querySelectorAll(".js-menu-item-mobile").forEach((item) => {
        if (Shopify.designMode) {
          const tempElement = item.querySelector(":scope > div:last-child");
          const md5Code = tempElement.classList[0];
          const megaMenuSection = document.querySelector(`.drawer-sub-menu-editor[data-code="${md5Code}"]`);
          if (!megaMenuSection)
            return;
          const megaMenuSectionClone = megaMenuSection.cloneNode(true);
          megaMenuSectionClone.classList.remove("d-none");
          item.appendChild(megaMenuSectionClone);
          tempElement.remove();
        }
        if (item.querySelector(":scope > [data-trigger]")) {
          if (!item.querySelector(":scope > [only-banner]")) {
            item.addClass("has-dropdown");
            item.addClass("mega-menu-item");
            item.querySelector(":scope > .js-open-sub-drawer").setAttribute("aria-expanded", false);
            item.querySelector(":scope > [data-trigger] > .drawer-wrapper > .drawer-top > .drawer-top__link").href = item.querySelector(":scope > button").dataset.link;
          } else {
            item.removeClass("has-dropdown");
          }
          if (item.querySelector(":scope > .drawer-sub-menu:not([data-trigger])")) {
            item.querySelector(":scope > .drawer-sub-menu:not([data-trigger])").remove();
          }
        }
      });
      const toggleButtons = mobileDrawerMenu.querySelectorAll(".js-open-sub-drawer");
      const backButtons = mobileDrawerMenu.querySelectorAll(".js-btn-back");
      toggleButtons.forEach((button) => button.addEventListener("click", this.#openSubDrawer.bind(this)));
      backButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          this.#closeSubDrawer(e.target.closest(".active"));
        });
      });
      mobileDrawerMenu.removeEventListener("keyup", this.#handleEscapeEvent.bind(this));
      mobileDrawerMenu.addEventListener("keyup", this.#handleEscapeEvent.bind(this));
    }
    openDrawer() {
      const { mobileDrawerMenu, mobileDrawerHamburger } = this.elms.drawerElms;
      if (!mobileDrawerMenu)
        return;
      AT.disableScroll();
      mobileDrawerMenu.classList.add("active");
      mobileDrawerHamburger.setAttribute("aria-expanded", true);
      this.classList.add("menu-drawer--is-open");
      this.drawerFocusTrap.trap.activate();
    }
    closeDrawer() {
      const { mobileDrawerMenu, mobileDrawerHamburger } = this.elms.drawerElms;
      if (!mobileDrawerMenu)
        return;
      this.drawerFocusTrap.trap.deactivate();
      this.classList.remove("menu-drawer--is-open");
      AT.enableScroll();
      mobileDrawerMenu.classList.remove("active");
      mobileDrawerHamburger.setAttribute("aria-expanded", false);
      mobileDrawerMenu.querySelectorAll("li.active").forEach((li) => li.classList.remove("active"));
      mobileDrawerMenu.querySelectorAll("ul.sub-open").forEach((ul) => ul.classList.remove("sub-open"));
      mobileDrawerMenu.querySelectorAll('[aria-expanded="true"]').forEach((item) => item.setAttribute("aria-expanded", false));
    }
    #openSubDrawer(e) {
      const { mobileDrawerMenu } = this.elms.drawerElms;
      const target = e.target;
      if (!target.closest("li").classList.contains("has-dropdown") || !mobileDrawerMenu)
        return;
      const focusableElements = this.#getFocusableElements(mobileDrawerMenu);
      focusableElements.forEach((element) => {
        if (!element.closest(".drawer-footer") && !target.nextElementSibling.contains(element)) {
          element.tabIndex = -1;
        }
      });
      target.closest("li").addClass("active");
      target.closest("ul").addClass("sub-open");
      target.setAttribute("aria-expanded", true);
      setTimeout(() => {
        target.nextElementSibling.querySelector(".js-btn-back").focus();
      }, 360);
    }
    #closeSubDrawer(activeElement) {
      const focusableElements = this.#getFocusableElements(activeElement.closest(".drawer-wrapper"));
      focusableElements.forEach((element) => {
        element.tabIndex = 0;
      });
      activeElement.removeClass("active");
      activeElement.closest("ul").removeClass("sub-open");
      activeElement.querySelector(".js-open-sub-drawer").focus();
      activeElement.querySelector(".js-open-sub-drawer").setAttribute("aria-expanded", false);
    }
    #handleEscapeEvent(e) {
      const { mobileDrawerMenu } = this.elms.drawerElms;
      const target = e.target;
      if (e.code.toUpperCase() !== "ESCAPE" || !mobileDrawerMenu)
        return;
      let activeElement = null;
      if (target.closest(".drawer-footer")) {
        const activeElements = mobileDrawerMenu.querySelectorAll("li.has-dropdown.active");
        if (activeElements.length == 0) {
          activeElement = target.closest(".active");
        } else {
          activeElement = activeElements[activeElements.length - 1];
        }
      } else {
        activeElement = target.closest(".active");
      }
      if (!activeElement)
        return;
      if (activeElement === mobileDrawerMenu) {
        this.closeDrawer();
      } else {
        this.#closeSubDrawer(activeElement);
      }
    }
    #getFocusableElements(container) {
      return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
    }
    initEditorEvents() {
      if (!Shopify.designMode)
        return;
      this.onSectionChange = (e) => {
        if (e.target.classList.contains("section-mega-menu")) {
          setTimeout(() => {
            if (this.elms.desktopMenu && this.elms.desktopMenuOrigin) {
              this.elms.desktopMenu.innerHTML = this.elms.desktopMenuOrigin.innerHTML;
              this.initDesktopNavigation();
            }
            const { mobileDrawerMenu, mobileDrawerMenuOrigin } = this.elms.drawerElms;
            if (mobileDrawerMenu) {
              mobileDrawerMenu.querySelector(".menu-list--lv0").classList.remove("sub-open");
              mobileDrawerMenu.querySelector(".menu-list--lv0").innerHTML = mobileDrawerMenuOrigin.querySelector(".menu-list--lv0").innerHTML;
              this.bindDrawerEvents();
            }
          }, 50);
        }
      };
      this.editorSelectEventCallback = (e) => {
        document.querySelectorAll(".section-mega-menu").forEach((section) => section.classList.remove("open"));
        if (e.target.classList.contains("section-mega-menu")) {
          if (window.innerWidth >= 992) {
            const menuItemHandle = e.target.querySelector("mega-menu").dataset.trigger;
            const menuItem = document.querySelector(`[data-menu-item-handle="${menuItemHandle}"]`);
            this.#adjustMegaContentPosition(menuItem, e.target);
            e.target.classList.add("open");
          }
        }
      };
      document.addEventListener("shopify:section:load", this.onSectionChange);
      document.addEventListener("shopify:section:unload", this.onSectionChange);
      document.addEventListener("shopify:section:select", this.editorSelectEventCallback);
    }
  };
  customElements.define("c-header", CustomHeader);
})();
